import { Controller } from "@hotwired/stimulus"

// 取扱分野の選択画面。小分類を選ぶと親の大分類も選び、大分類を外すとその小分類も外す
// (小分類を持つ弁護士は親の大分類も持つ。doc/issues/261018_bengoshi_map_practice_area_master.md §8.2)
export default class extends Controller {
  static targets = ["parent", "child"]

  checkParent(event) {
    if (!event.currentTarget.checked) return

    const parent = this.parentTargets.find((checkbox) => checkbox.value === event.currentTarget.dataset.parentId)
    parent.checked = true
  }

  uncheckChildren(event) {
    if (event.currentTarget.checked) return

    this.childTargets
      .filter((checkbox) => checkbox.dataset.parentId === event.currentTarget.value)
      .forEach((checkbox) => { checkbox.checked = false })
  }
}
